import { render, staticRenderFns } from "./QuizRootLectureView.vue?vue&type=template&id=abff3760"
import script from "./QuizRootLectureView.vue?vue&type=script&lang=js"
export * from "./QuizRootLectureView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports